import React, { FC } from 'react';
import GameOfLife from '../../components/GameOfLife';

const Home: FC = () => {
  return <GameOfLife />;
};

export default Home;
